import { CtaFooter } from 'features/Home/components/CtaFooter'
import { CtaBannerWrapper } from './CtaBanner.styles'
import { useScrollToTop } from 'hooks/useScrollToTop'

export const CtaBanner = () => {
  const scrollToTop = useScrollToTop()

  return (
    <CtaBannerWrapper>
      <CtaFooter
        title="products-v2:freeze-dried-raw-nuggets.cta-banner.title"
        cta="products-v2:freeze-dried-raw-nuggets.cta-banner.cta"
        onCtaClick={() => scrollToTop('smooth')}
        hideSecondaryCta
      />
    </CtaBannerWrapper>
  )
}

CtaBanner.displayName = 'CtaBanner'
